import React, { useState } from 'react';

export default function LocationButton({ mapRef, nameRegion, navigate, isDesktop }) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    console.log('NOMEREGIONE=' + nameRegion)
    // Bounds delle regioni italiane
    const regionBounds = {
        'piemonte': { north: 46.5, south: 44.1, east: 9.2, west: 6.6 },
        'valle_di_aosta': { north: 46.0, south: 45.5, east: 7.9, west: 6.7 },
        'lombardia': { north: 46.6, south: 44.6, east: 11.5, west: 8.5 },
        'trentino_alto_adige': { north: 47.1, south: 45.7, east: 12.5, west: 10.4 },
        'veneto': { north: 46.7, south: 44.8, east: 13.0, west: 10.6 },
        'friuli_venezia_giulia': { north: 46.7, south: 45.5, east: 13.9, west: 12.3 },
        'liguria': { north: 44.7, south: 43.8, east: 10.1, west: 7.5 },
        'emilia_romagna': { north: 45.1, south: 43.7, east: 12.8, west: 9.2 },
        'toscana': { north: 44.4, south: 42.2, east: 12.4, west: 9.7 },
        'umbria': { north: 43.6, south: 42.4, east: 13.3, west: 11.9 },
        'marche': { north: 44.0, south: 42.7, east: 13.9, west: 12.2 },
        'lazio': { north: 42.8, south: 40.8, east: 13.9, west: 11.5 },
        'abruzzo': { north: 42.9, south: 41.7, east: 14.8, west: 13.1 },
        'molise': { north: 42.0, south: 41.4, east: 15.2, west: 14.1 },
        'campania': { north: 41.5, south: 40.0, east: 15.8, west: 13.8 },
        'puglia': { north: 42.2, south: 39.8, east: 18.5, west: 14.9 },
        'basilicata': { north: 40.9, south: 39.9, east: 16.9, west: 15.4 },
        'calabria': { north: 40.2, south: 37.9, east: 17.2, west: 15.6 },
        'sicilia': { north: 38.8, south: 36.6, east: 15.6, west: 12.4 },
        'sardegna': { north: 41.3, south: 38.9, east: 9.8, west: 8.1 }
    };

    const isInRegion = (lat, lon, regionName) => {
        const bounds = regionBounds[regionName];
        if (!bounds) return true; // fallback sicuro

        const buffer = 0.05; // ≈5km, sufficiente per imprecisioni GPS e confini

        return lat <= (bounds.north + buffer) &&
            lat >= (bounds.south - buffer) &&
            lon <= (bounds.east + buffer) &&
            lon >= (bounds.west - buffer);
    };

    const addUserMarker = (map, lat, lon) => {
        map.eachLayer((layer) => {
            if (layer.options && layer.options.className === 'user-location-marker') {
                map.removeLayer(layer);
            }
        });

        const L = window.L;
        const marker = L.marker([lat, lon], {
            icon: L.divIcon({
                className: 'user-location-marker',
                html: `<div style="
          width: 20px; 
          height: 20px; 
          background: #4285F4; 
          border: 3px solid white; 
          border-radius: 50%; 
          box-shadow: 0 2px 6px rgba(0,0,0,0.4);
        "></div>`,
                iconSize: [20, 20],
                iconAnchor: [10, 10]
            })
        }).addTo(map);

        marker.bindPopup('📍 Sei qui').openPopup();

        setTimeout(() => {
            if (map.hasLayer(marker)) {
                marker.remove();
            }
        }, 10000);
    };

    const handleLocationClick = () => {
        if (!navigator.geolocation) {
            setError('Geolocalizzazione non supportata dal browser');
            setTimeout(() => setError(null), 3000);
            return;
        }

        setLoading(true);
        setError(null);

        navigator.geolocation.getCurrentPosition(
            (position) => {
                const { latitude, longitude } = position.coords;

                if (!nameRegion) {
                    if (mapRef.current) {
                        mapRef.current.setView([latitude, longitude], 13);
                        addUserMarker(mapRef.current, latitude, longitude);
                    }
                    setLoading(false);
                    return;
                }

                if (isInRegion(latitude, longitude, nameRegion)) {
                    if (mapRef.current) {
                        mapRef.current.setView([latitude, longitude], 13);
                        addUserMarker(mapRef.current, latitude, longitude);
                    }
                } else {
                    if (window.confirm(`Sei fuori dalla regione ${nameRegion}. Vuoi tornare alla mappa centrale?`)) {
                        navigate('/');
                    }
                }

                setLoading(false);
            },
            (err) => {
                setLoading(false);

                switch (err.code) {
                    case err.PERMISSION_DENIED:
                        setError('Permesso negato. Abilita la geolocalizzazione nelle impostazioni del browser.');
                        break;
                    case err.POSITION_UNAVAILABLE:
                        setError('Posizione non disponibile.');
                        break;
                    case err.TIMEOUT:
                        setError('Timeout nella richiesta di posizione.');
                        break;
                    default:
                        setError('Errore nella geolocalizzazione.');
                }

                setTimeout(() => setError(null), 4000);
            },
            {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 0
            }
        );
    };

    // ⭐ STILE IDENTICO AD AI FAB - Viola con animazione alternata
    const buttonStyle = {
        position: 'fixed !important', // ⭐ Sempre fixed per evitare problemi con scrollbar
        bottom: isDesktop ? '30px !important' : '20px !important',
        right: isDesktop ? '110px !important' : '20px !important', // ⭐ A sinistra dell'AI button su desktop
        width: isDesktop ? '80px !important' : '100px !important', // ⭐ Stesse dimensioni AI FAB
        height: isDesktop ? '80px !important' : '100px !important',
        borderRadius: '50%',
        background: loading
            ? '#e0e0e0'
            : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', // ⭐ Stesso viola AI FAB
        color: 'white',
        border: 'none',
        boxShadow: loading
            ? '0 4px 12px rgba(0,0,0,0.2)'
            : '0 8px 30px rgba(0, 0, 0, 0.5)', // ⭐ Stessa ombra AI FAB
        cursor: loading ? 'wait' : 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: isDesktop ? '40px !important' : '50px !important', // ⭐ Stesso size emoji
        zIndex: '1000 !important',
        transition: 'transform 0.2s, box-shadow 0.2s',
        animation: loading ? 'none' : 'blink-location-fab 1.2s ease-in-out infinite' // ⭐ Animazione alternata
    };

    return (
        <>
            <button
                onClick={handleLocationClick}
                disabled={loading}
                title="Vai alla mia posizione"
                className="location-fab" // ⭐ Classe per CSS
                style={buttonStyle}
                onMouseEnter={(e) => {
                    if (!loading) {
                        e.currentTarget.style.transform = 'scale(1.15)';
                        e.currentTarget.style.boxShadow = '0 10px 40px rgba(102, 126, 234, 0.7)';
                        e.currentTarget.style.animationPlayState = 'paused';
                    }
                }}
                onMouseLeave={(e) => {
                    if (!loading) {
                        e.currentTarget.style.transform = 'scale(1)';
                        e.currentTarget.style.boxShadow = '0 8px 30px rgba(0, 0, 0, 0.5)';
                        e.currentTarget.style.animationPlayState = 'running';
                    }
                }}
            >
                {loading ? '⏳' : '🎯'}
            </button>

            {/* Error Toast */}
            {error && (
                <div style={{
                    position: 'fixed',
                    bottom: isDesktop ? '120px' : '130px',
                    right: isDesktop ? '110px' : '20px',
                    background: '#f44336',
                    color: 'white',
                    padding: '12px 16px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                    zIndex: 1001,
                    maxWidth: '300px',
                    fontSize: '14px',
                    animation: 'slideInFromRight 0.3s ease'
                }}>
                    ⚠️ {error}
                </div>
            )}

            {/* CSS Animations */}
            <style>{`
        @keyframes slideInFromRight {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
        </>
    );
}